module.exports = __webpack_public_path__ + "img/bg5.01a16bdc.jpg";